export { ResumenCierresTab } from "./ResumenCierresTab";
